export default __webpack_public_path__ + "static/media/meetings.e95b9b70.svg";